import { render, staticRenderFns } from "./layout-sidebar.vue?vue&type=template&id=2d2d10c0&scoped=true&"
import script from "./layout-sidebar.vue?vue&type=script&lang=js&"
export * from "./layout-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./layout-sidebar.vue?vue&type=style&index=0&id=2d2d10c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2d10c0",
  null
  
)

export default component.exports